import { MiddlewareAPI, Store, Dispatch, Reducer, Action } from "redux";
import { actions as commonActions } from "../modules/common";
import createBrowserHistory from "history/createBrowserHistory";
import * as H from "history";

export const routerMiddleware =
  (history: H.History) =>
  (store: Store<any>) =>
  (next: Dispatch<any>) =>
  (action: any) => {
    if (action.type == commonActions.REDIRECT_TO) {
      history.push(action.payload);
    }
    return next(action);
  };



// WEBPACK FOOTER //
// ./client/middlewares/router_middleware.ts